<template>
  <div class="wds-alert-group">
    <WdsAlert v-if="errors.length" title="Error" error closable @close="errors = []">
      <template #description>
        <span v-for="(error, index) in errors" :key="index">
          {{ error }}
          <br />
        </span>
      </template>
    </WdsAlert>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { WdsAlert } from '@worksome/wds-components'

export default defineComponent({
  name: 'ErrorMessages',

  components: {
    WdsAlert,
  },

  data() {
    return {
      errors: sessionErrors,
    }
  },
})
</script>

<style scoped>
.wds-alert-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
